import { CheckboxField, SelectField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { PanelContentContainer, PanelContentHeader, PanelContentSubtitle, PanelContentTitle } from '../styles';
const checkboxContainerCss = "ck5evik";
const CheckboxContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(checkboxContainerCss, props.className)} />;
});
const getNameFormatOptions = () => [{
  name: I18n.t('publisher.event_types.invitee_questions.name_and_email'),
  value: 'combined'
}, {
  name: I18n.t('publisher.event_type_editor.sections.booking_page_options.invitee_questions.first_name_last_name_email'),
  value: 'separated'
}];
export const InviteeDetailsSection = () => <PanelContentContainer section>
    <PanelContentHeader>
      <PanelContentTitle>
        {I18n.t('publisher.event_type_editor.sections.more_options.invitee_form.invitee_details')}
      </PanelContentTitle>
      <PanelContentSubtitle>
        {I18n.t('publisher.event_type_editor.sections.more_options.invitee_form.question_helper')}
      </PanelContentSubtitle>
    </PanelContentHeader>
    <PanelContentContainer subsection>
      <SelectField aria-label={I18n.t('publisher.event_type_editor.sections.more_options.invitee_form.name_format')} name="nameFormat" id="name-format-input" options={getNameFormatOptions()} />
      <CheckboxContainer>
        <CheckboxField aria-label={I18n.t('publisher.event_type_editor.sections.more_options.invitee_form.autofill_label')} name="bookingAutofill" />
        <BodyText size="medium">{I18n.t('publisher.event_types.invitee_questions.autofill_from_prior_bookings')}</BodyText>
      </CheckboxContainer>
    </PanelContentContainer>
  </PanelContentContainer>;

require("./invitee_details_section.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./invitee_details_section.js");